import React from 'react';
import Hero from '../components/Hero';
import Stats from '../components/Stats';
import Services from '../components/Services';
import About from '../components/About';
import Projects from '../components/Projects';
import Blog from '../components/Blog';
import FAQSection from '../components/faq/FAQSection';

const HomePage = () => {
  return (
    <main>
      <Hero />
      <Stats />
      <Services />
      <About />
      <Projects />
      <Blog />
      <FAQSection />
    </main>
  );
};

export default HomePage;